import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import TextArea from '../../../../Atoms/TextArea';
import ButtonMain from '../../../../Atoms/ButtonMain';
import ButtonSecondary from '../../../../Atoms/ButtonSecondary';
import './styles.css';

export default function EditGuidingQuestionModal({ 
    show, 
    onHide, 
    question, 
    onConfirm 
}) {
    const [editedText, setEditedText] = useState('');

    useEffect(() => {
        if (question) {
            setEditedText(question.text || '');
        }
    }, [question]);

    const handleConfirm = () => {
        if (editedText.trim() && onConfirm) {
            onConfirm(editedText.trim());
            onHide();
        }
    };

    const handleCancel = () => {
        setEditedText(question?.text || '');
        onHide();
    };

    const isDisabled = !editedText.trim() || editedText.trim() === question?.text;

    return (
        <Modal 
            show={show} 
            onHide={handleCancel}
            centered
            backdrop="static"
            className="edit-guiding-question-modal"
        >
            <Modal.Header closeButton className="edit-guiding-question-modal-header">
                <Modal.Title>Editar Pergunta Norteadora</Modal.Title>
            </Modal.Header>
            
            <Modal.Body className="edit-guiding-question-modal-body">
                <TextArea
                    placeholder="Descreva a pergunta norteadora. Como podemos ...?"
                    value={editedText}
                    onChange={(e) => setEditedText(e.target.value)}
                    maxLength={500}
                    textAreaStyle={{ minHeight: '120px' }}
                    containerStyle={{ padding: '0px' }}
                />
                <div className="character-count">
                    {editedText.length}/500 caracteres
                </div>
            </Modal.Body>
            
            <Modal.Footer className="edit-guiding-question-modal-footer">
                <ButtonSecondary onClick={handleCancel}>
                    Cancelar
                </ButtonSecondary>
                <ButtonMain 
                    onClick={handleConfirm}
                    disabled={isDisabled}
                >
                    Confirmar
                </ButtonMain>
            </Modal.Footer>
        </Modal>
    );
}
